
<header class="head d-flex justify-content-center align-items-center">

    <div class="head-caption text-center">
     <h1>ABOUT US</h1>
     <p>Read our Story, How we started and about the Team</p>
    </div>
 
 </header>
 <!--start section about -->
 <section class="container py-5 about">
     <div class="row">

        <div class="col-lg-5 col-md-12">
            <div class="py-4">
                <img src="assets/images/about.png" class="img-fluid" alt="table">
            </div>
        </div>
        <div class="col-lg-7 col-md-12 d-flex justify-content-center align-items-center">
            <div class="py-4 about-caption">
                <h2 class="mt-4">OUR STORY</h2>
                <p class="mt-3">Lorem Ipsum is simply dummy text of the printing and <br> typesetting industry.
                   Lorem Ipsum has been the industry's <br> standard dummy text ever since the 1500s,
                   when an unknown <br> printer took a galley of type and scrambled it to make a typed <br>  specimen
                   book. It has survived not only five centuries,  but also <br> the leap into electronic
                    typesetting, remaining essentially <br> unchanged. It was popularised 
                    in the 1960s with the release of <br> Letraset sheets containing Lorem Ipsum passage
                </p>
                <button class="border-0 mt-3 py-2 px-3 text-dark">SEE OUR MENU</button>

            </div>
        </div>

     </div>
 </section>
 <!--end section about -->

 <!-- start section service-->
 <section class="special py-5">
    
    <div class="container">
        <div class="fixid-content text-center text-white pb-5"> 
            <h1>SPECIAL SERVICE</h1>
            <p>What Special services we are offering now</p>
            <div class="mini m-auto mb-5"></div>
        </div> 

        
        <div data-slick='{"slidesToShow": 2, "slidesToScroll": 1}' class="slider text-white pt-4">
                
                    
                        <div class="special-caption position-relative">
                            
                               <img src="assets/images/ico1.png" class="" alt="icon-wedding">
                            
                            <div class="special-content">
                                <h3>BIRTHDAY PARTY</h3>
                                <P class="pb-5">Lorem Ipsum is simply dummy text of the printing. <br> and typesetting industry. 
                                    Lorem Ipsum has been the <br> industry's standard dummy text ever since the 1500s.
                                </P>
                            </div>
                        </div>
                        <div class="special-caption position-relative">
                            <img src="assets/images/ico2.png" class="" alt="icon-wedding">
                            <div class="special-content">
                                <h3>WEDDING PARTY</h3>
                                <P class="pb-5">Lorem Ipsum is simply dummy text of the printing. <br> and typesetting industry. 
                                    Lorem Ipsum has been the <br> industry's standard dummy text ever since the 1500s.
                                </P>
                            </div>
                        </div>
                        <div class="special-caption">
                            <img src="assets/images/ico1.png" class="" alt="icon-wedding">
                            <div class="special-content">
                              <h3>BIRTHDAY PARTY</h3>
                              <P>Lorem Ipsum is simply dummy text of the printing <br> and typesetting industry. 
                                 Lorem Ipsum has been the <br> industry's standard dummy text ever since the 1500s.
                              </P>
                            </div>
                        </div>
                        
                        <div class="special-caption pb-5">
                            <img src="assets/images/ico2.png" class="" alt="icon-wedding">
                            <div class="special-content">
                                <h3>WEDDING PARTY</h3>
                                <P>Lorem Ipsum is simply dummy text of the printing <br> and typesetting industry. 
                                   Lorem Ipsum has been the <br> industry's standard dummy text ever since the 1500s.
                                </P>
                            </div>
                        </div>
        </div>

    
    </div>
 </section>
<!-- end section service-->

<!-- start section our team-->
<section class="container py-5 team">
    <div class="fixid-content text-center pb-5"> 
        <h1>OUR TEAM</h1>
        <p class="text-muted">The Hardworking Team behind the restaurant</p>
        <div class="mini m-auto mb-5"></div>
     </div> 

     <div class="row">


        <div class="col-lg-3 col-md-6">
            <div class="text-center team-caption"> 
                <img src="assets/images/man1.png" class="img-fluid" alt="">
                <h6 class="pt-4">ENTER NAME HERE</h6>
                <p>Designation here</p>
                <div class="team-ico">
                    <i class="fab fa-facebook-f mr-3"></i>
                    <i class="fab fa-twitter mr-3"></i>
                    <i class="fab fa-google"></i>
                </div>
                <div class="brdr pt-4"></div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6">
            <div class="text-center team-caption"> 
                <img src="assets/images/woman1.png" class="img-fluid" alt="">
                <h6 class="pt-4">ENTER NAME HERE</h6>
                <p>Designation here</p>
                <div class="team-ico">
                    <i class="fab fa-facebook-f mr-3"></i>
                    <i class="fab fa-twitter mr-3"></i>
                    <i class="fab fa-google"></i>
                </div>
                <div class="brdr pt-4"></div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6">
            <div class="text-center team-caption"> 
                <img src="assets/images/woman2.png" class="img-fluid" alt="">
                <h6 class="pt-4">ENTER NAME HERE</h6>
                <p>Designation here</p>
                <div class="team-ico">
                    <i class="fab fa-facebook-f mr-3"></i>
                    <i class="fab fa-twitter mr-3"></i>
                    <i class="fab fa-google"></i>
                </div>
                <div class="brdr pt-4"></div>
            </div>
        </div>
        <div class="col-lg-3 col-md-6">
            <div class="text-center team-caption"> 
                <img src="assets/images/man2.png" class="img-fluid" alt="">
                <h6 class="pt-4">ENTER NAME HERE</h6>
                <p>Designation here</p>
                <div class="team-ico">
                    <i class="fab fa-facebook-f mr-3"></i>
                    <i class="fab fa-twitter mr-3"></i>
                    <i class="fab fa-google"></i>
                </div>
                <div class="brdr pt-4"></div>
            </div>
        </div>




     </div>
</section>
<!-- end section our team-->
 
<!-- start section testimonials -->

<section class="mt-5 testimonials">
    <div class="container">
        <div data-slick='{"slidesToShow": 1, "slidesToScroll": 1}' class="testimonial text-white pt-4">
                
                    
            <div class="testimonial-caption text-center">
                <img src="assets/images/quote.png" class="text-white my-5" alt="">
                <p >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Fugiat  quam tempore unde voluptates ipsum ut, obcaecati laudantium 
                      reiciendis quia sunt ea dolores ad porro repellat
                   , sint  voluptatibus tempora et delectus! Lorem ipsum 
                   dolor sit amet  consectetur adipisicing elit.
                   Voluptatum id officia repellat amet  expedita enim odio unde quas</p>
                   <p>Anthony Reed, <span>New York</span>
                </p>
            </div>
            <div class="testimonial-caption text-center">
                <img src="assets/images/quote.png" class="text-white my-5" alt=""> 
                <p >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Fugiat quam tempore unde voluptates ipsum ut, obcaecati laudantium 
                      reiciendis quia sunt ea dolores ad porro repellat
                   , sint  voluptatibus tempora et delectus! Lorem ipsum 
                   dolor sit amet  consectetur adipisicing elit.
                   Voluptatum id officia repellat amet expedita enim odio unde quas</p>
                   <p>Gemma Arterton, <span>Bay Area</span>
                </p>
            </div>
            <div class="testimonial-caption text-center">
                <img src="assets/images/quote.png" class="text-white my-5" alt="">
                <p >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Fugiat  quam tempore unde voluptates ipsum ut, obcaecati laudantium 
                      reiciendis quia sunt ea dolores ad porro repellat
                   , sint voluptatibus tempora et delectus! Lorem ipsum 
                   dolor sit amet  consectetur adipisicing elit.
                   Voluptatum id officia repellat amet  expedita enim odio unde quas</p>
                   <p>Zachary Burton, <span>Sanfransisco</span>
                </p>
            </div>
            
        </div>
    </div>
</section>

<!-- end section testimonials -->
 
<!--start section insta-->
<section class="bg">

    <div class="container py-4">

     <div class="row insta-caption">
        <div class="col-md-3 sub-caption">
            <p>SUBSCRIBE</p>
        </div>
        <div class="col-md-8">
         <p class="text-muted p">Get updates about new dishes and upcoming events</p>
     </div>
       
       </div>
       <div class="registers d-flex justify-content-end pb-4">
         <input class="inpt-caption mr-4" type="email" placeholder=" Your Email Address ">
         <button type="submit" class="register"><i class="fas fa-chevron-right fa-1x"></i></button>
       </div>

    </div>
</section>

<!--end section insta-->



